import { Factory } from 'rosie';

Factory.define('Audience').attr('name', 'AUDIENCE');

Factory.define('AudienceWithDefaults')
  .extend('Audience')
  .attr('id', 'default-id')
  .attr('name', 'default-name');
